<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="1.5" class="background-circular" src="/assets/img/background-circular.svg"
    alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.5" class="background-circular"
    src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />

<mat-sidenav-container>

    <!-- Only Mobile -->
    <mat-sidenav #filters mode="over" [fixedInViewport]="true" class="filters-sidenav">
        <mat-toolbar>
            <h4>Filtros de búsqueda</h4>
            <span class="example-spacer"></span>
            <div class="close-sidenav" (click)="filters.toggle()"><span class="jam jam-close"></span></div>
        </mat-toolbar>
        <app-filters [priceRange]="priceRange" [priceBounds]="priceBounds" [brands]="brands" [selectedBrandIds]="selectedBrandIds" [isPriceFilterActiveFromParent]="isPriceFilterActive" (applyPrice)="applyFilterPrice($event)" (applyStock)="applyFilterStock($event)" (applyBrand)="applyFilterBrand($event)"></app-filters>

        <div class="buttons">
            <button mat-button type="button" class="clean-filters" fxFlex="50%" (click)="cleanFilters()">Limpiar Filtros</button>

            <button mat-button class="results" fxFlex="50%" (click)="filters.toggle()" [ngClass]="{'loading':loading}">
                <span *ngIf="!loading">Ver {{ dataItems.total }} resultados</span>
                <span *ngIf="loading">
                    <mat-spinner [diameter]=30></mat-spinner>
                </span>
            </button>
        </div>
    </mat-sidenav>

    <app-navbar></app-navbar>

    <!-- Nav Block Promo -->
    <div *ngIf="bannerData && bannerData.is_show_banner" class="nav-block-promo" fxLayoutAlign="center start" [ngStyle]="{'background': 'url(' + bannerData.image_product + ')', 'background-position': 'center', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
        <div fxLayout="row" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
            <p><span>{{ bannerData.first_text }}</span> {{ bannerData.two_text }}</p>
            <button *ngIf="bannerData.is_show_button" mat-button routerLinkActive="router-link-active" (click)="clickBanner()">{{ bannerData.button_text }}</button>
        </div>
    </div>

    <!-- Search -->
    <div class="search" fxLayoutAlign="center start">
        <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1200px" fxFlex.lt-md="100%" fxFlex.md="90%"
            fxLayoutGap="30px" fxLayoutGap.xs="0px">

            <!-- Filters Lateral Bar -->
            <div fxFlex="25%" fxHide.lt-md>
                <app-breadcrumb [queryText]="searchText" [category]="category"></app-breadcrumb>
                <app-filters [priceRange]="priceRange" [priceBounds]="priceBounds" [brands]="brands" [selectedBrandIds]="selectedBrandIds" [isPriceFilterActiveFromParent]="isPriceFilterActive" (applyPrice)="applyFilterPrice($event)" (applyStock)="applyFilterStock($event)" (applyBrand)="applyFilterBrand($event)"></app-filters>
            </div>

            <!-- Products Filter -->
            <div fxFlex="75%">

                <!-- only show Mobile -->
                <div fxHide fxShow.lt-md class="title-mobile">
                    <app-breadcrumb [queryText]="searchText" [category]="category"></app-breadcrumb>
                    <h2>{{ getTitleSearch() }}</h2>

                    <button mat-button>
                        <mat-form-field>
                            <mat-label>Ordenar</mat-label>
                            <mat-select [(value)]="orderType" (selectionChange)="loadSearch()">
                                <mat-option [value]="0"> Precio</mat-option>
                                <mat-option [value]="1"> Popularidad</mat-option>
                                <mat-option [value]="2"> Orden Alfabético</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!-- <span class="jam jam-signal"></span> Ordenar <span class="jam jam-chevron-down"></span> -->
                    </button>
                    <button mat-button (click)="filters.toggle()"><span class="jam jam-settings-alt"></span>
                        Filtros</button>
                </div>

                <div fxHide.lt-md class="title">
                    <h2>{{ dataItems.total }} Productos encontrados</h2>
                    <div class="sort-by">
                        <p>Ordenar por:</p>
                        <mat-form-field>
                            <mat-select [(value)]="orderType" (selectionChange)="loadSearch()">
                                <mat-option [value]="0"> Precio</mat-option>
                                <mat-option [value]="1"> Popularidad</mat-option>
                                <mat-option [value]="2"> Orden Alfabético</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <hr>
                </div>

                <!-- No products found message -->
                <div class="no-results" *ngIf="dataItems.total === 0 && (isPriceFilterActive || selectedBrandIds.length > 0)">
                    <div class="no-results-content">
                        <span class="material-icons">search_off</span>
                        <h3>No se encontraron productos</h3>
                        <p>No hay productos que coincidan con los filtros seleccionados.</p>
                        <p class="hint" *ngIf="selectedBrandIds.length > 0">Intenta seleccionar otras marcas o ajustar el rango de precios.</p>
                        <button mat-stroked-button (click)="cleanFilters()">Limpiar filtros</button>
                    </div>
                </div>

                <div class="filter-results" *ngIf="dataItems.total > 0">
                    <app-product-card *ngFor="let item of dataItems.data" [product]="item"></app-product-card>
                    <mat-paginator
                    [pageIndex]="matPageIndex" [length]="dataItems.total" [pageSize]="tableModel.itemPerPage" [pageSizeOptions]="[5, 10, 25, 50, 100]" (page)="onPageChange($event)"
                    >
                    </mat-paginator>
                </div>
            </div> <!-- fxFlex 75% -->
        </div> <!-- fxLayout Row 1280px -->
    </div> <!-- search -->


    <app-footer></app-footer>
</mat-sidenav-container>
